import Vue from "vue";
import Router from "vue-router";
import layout from "./views/layout.vue";
import store from "./store.js"



function fun(res, n=0){             //获取menu
  n++;
  let v = [];
  
  for(let i=0;i<res.length;i++){
    if( n == 1 ){
      v.push({ id:n,path: res[i].url,name: res[i].title,component:eval( () => import("./views"+res[i].url+".vue")),redirect: res[i].children.length >0 ? res[i].children[0].url : null,children: fun(res[i].children,n)})
    }else {
      if(  (res[i].isButton === 0 || n == 2) ){
        v.push({ id:n,path: res[i].url,name: res[i].title,component:eval( () => import("./views"+res[i].url+".vue")),children: fun(res[i].children,n)})
      } 
    }
  }
  return v;
}



// console.log(111,fun2(store.state.menu))
// console.log(store.state.menu)
// console.log('fun(store.state.menu)',fun(store.state.menu))

let routes = [
  {
    path: "/",
    name: "/login",
    component: () => import("./views/login.vue")
  },
  {
    path: "/layout",
    name: "/layout",
    component: () => import("./views/layout.vue"),
    redirect: "/layout/home",
    children: fun(store.state.menu)

   },
   {
    path: "*",
    name: "NULL",
    component: () => import("./views/NULL.vue"),
    path: "/NULL"
    
    
  }

]
console.log('路由',routes)
Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes
});


